import { useEffect, useState } from 'react';
import { Download, Smartphone } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [iosHint, setIosHint] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    setInstalled(!!standalone);
    const ua = window.navigator.userAgent.toLowerCase();
    const isIos = /iphone|ipad|ipod/.test(ua);
    setIosHint(isIos && !standalone);
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    return () => window.removeEventListener('beforeinstallprompt', onBeforeInstall);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  if (installed) return null;

  return (
    <div className="rounded-2xl border border-emerald-500/20 bg-emerald-500/10 p-4 space-y-3" data-testid="pwa-install-prompt">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-emerald-500/15 flex items-center justify-center"><Smartphone className="w-5 h-5 text-emerald-300" /></div>
        <div>
          <p className="text-sm font-semibold text-white">Instala la app móvil</p>
          <p className="text-[11px] text-emerald-100/75">Acceso rápido desde home, pantalla completa y experiencia tipo app.</p>
        </div>
      </div>
      {deferredPrompt && <Button onClick={install} className="w-full bg-emerald-500 hover:bg-emerald-400 text-black" data-testid="install-pwa-btn"><Download className="w-4 h-4 mr-2" />Agregar a pantalla de inicio</Button>}
      {iosHint && <p className="text-[11px] text-white/70">En iPhone/iPad: abre Compartir y luego “Agregar a pantalla de inicio”.</p>}
    </div>
  );
}